var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flash-modal',{attrs:{"id":"flash-modal-success","type":"success"}})
}
var staticRenderFns = []

export { render, staticRenderFns }